<template>

  <section class="loading_main"
           v-if="loading_bool">
    <section class="loading_item">
      <div class="load-container">
        <div class="load load1"></div>
        <div class="load load2"></div>
        <div class="load"></div>
      </div>

    </section>
  </section>

</template>

<script>
export default {
  name: 'loading',
  props: {
    loading_bool: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
.loading_main {
  width: 100%;
  min-height: 500px;
  margin: 0 auto;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
}
.load-container {
  margin: 0.5rem auto;
  width: 1.5rem;
  text-align: center;
  .load {
    width: 0.15rem;
    height: 0.15rem;
    background-color: rgba(0, 0, 0, 0.5);

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: bouncedelay 1.4s infinite ease-in-out;
    animation: bouncedelay 1.4s infinite ease-in-out;
    /* Prevent first frame from flickering when animation starts */
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }
  .load1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .load2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
}

@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}

@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/loading/loading.vue